<template>
    <div v-show="!props.hide">
        <sp-form
            class="mobile-general-form-user-select"
            :class="[`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''}`, `${notChanged ? 'disable-opacity' : ''}`]"
            ref="elForm"
            :model="formModel"
            :rules="rules"
        >
            <sp-form-item prop="userId">
                <sharp-comp-select
                    :label="i18nLabel"
                    :selected-options-text="selectedOptionsText"
                    :is-required="props.required && !globalModel.preview"
                    :readonly="globalModel.preview || globalModel.hideSubmitStyle"
                    :placeholder="dealPlaceHolder"
                    @click="onClick"
                ></sharp-comp-select>
                <div :class="['sp-form-item__error', errorMsg && 'has-error-msg']">
                    {{ errorMsg }}
                </div>
            </sp-form-item>
        </sp-form>
        <div v-if="userInfo" :class="['user-item', errorMsg && 'form-has-error-msg']">
            <csc-base-user-card :userCardInfo="userInfo" :isSelected="true"></csc-base-user-card>
        </div>
        <sub-title class="mt16 plr19 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
        <csc-user-panel
            :showPanel.sync="showPanel"
            :showLoading="showLoading"
            :tagList="tagList"
            :searchResult="searchResult"
            :showIo="showIo"
            :hasMoreData="hasMoreData"
            @search="handleSearch"
            @delete-history="deleteHistory"
            @choose-click="chooseClick"
            @load-more="loadMore"
            @update-loading="resetSearchData"
            @on-no-result-click="onNoRecord"
        >
            <sp-dialog
                v-model="showHistoryDialog"
                popupClass="delete-search"
                transferDom
                :content="'搜索记录删除后将无法恢复，确认删除全部搜索?'"
                :btns="btn"
            ></sp-dialog>
        </csc-user-panel>
    </div>
</template>
<script>
import { Form, FormItem, Dialog } from '@ks/sharp-ui';
import { component } from './props';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import ComponentBase from '../component-base';
import { fetchUserDetail, fetchUserList, setSearchRecord, getSearchRecord, STORAGE_KEY, removeSearchRecord } from './util';
import isEqual from 'lodash/isEqual';
import mobileDesign from '@ks-csc/mobile-design';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import { RESULT_FALLBACK_VALUE } from '../../const';
import SubTitle from '../component-base/common/sub-title';

const HIDE_NO_RESULT_OPTION_CLASS = 'hide-user-select-no-result-option';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SpDialog: Dialog,
        SharpCompSelect,
        CscUserPanel: mobileDesign.CscUserPanel,
        CscBaseUserCard: mobileDesign.CscBaseUserCard,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                userId: '',
            },
            showPanel: false,
            backed: false,
            showHistoryDialog: false,
            userInfo: null,
            errorMsg: '',
            selectedOptionsText: '',
            showLoading: false,
            tagList: getSearchRecord(STORAGE_KEY),
            searchResult: [],
            hasMoreData: true,
            showIo: false,
            page: 0,
            btn: [
                {
                    text: '取消',
                    handler: () => {
                        this.showHistoryDialog = false;
                    },
                },
                {
                    text: '确定',
                    handler: () => {
                        removeSearchRecord(STORAGE_KEY);
                        this.tagList = [];
                        this.showHistoryDialog = false;
                    },
                },
            ],
        };
    },
    computed: {
        rules() {
            return {
                // 不使用表单的校验来判断required 否则选择兜底项会无法通过
                userId: this.composeRules({
                    ...this.props,
                    required: false,
                }),
            };
        },
        placeholder() {
            return this.userIdValid(this.formModel.userId) ? this.props.seletedPlaceholder : this.props.placeholder;
        },
        dealPlaceHolder() {
            if (this.globalModel.noticeFormPreview && !this.userInfo) {
                return this.formModel.userId;
            }
            return !this.globalModel.preview && !this.globalModel.hideSubmitStyle ? this.i18n(this.placeholder) : '';
        },
        fallbackOptionEnabled() {
            return this.props.showNoResultOption !== false;
        },
        fallbackOptionVisible() {
            return this.fallbackOptionEnabled && !this.showLoading && this.searchResult.length > 0;
        },
    },
    watch: {
        fallbackOptionVisible() {
            this.updateNoResultOptionVisibility();
        },
        'formModel.userId': {
            immediate: true,
            handler(userId) {
                if (this.userIdValid(userId)) {
                    this.getUserInfo();
                    this.selectedOptionsText = '';
                } else {
                    this.userInfo = null;
                }
                if (userId === RESULT_FALLBACK_VALUE) {
                    this.updateFallbackText();
                }
            },
        },
        showPanel: {
            handler(value) {
                this.updateNoResultOptionVisibility();
                if (value) {
                    history.pushState('_PICKER_PAGE', '', location.href);
                    window.addEventListener('popstate', this.handlePopstate);
                } else {
                    if (!this.backed) {
                        window.history.go(-1);
                    }
                    window.removeEventListener('popstate', this.handlePopstate);
                }
            },
        },
        'props.showNoResultOption'() {
            this.updateNoResultOptionVisibility();
            if (this.formModel.userId === RESULT_FALLBACK_VALUE) {
                this.updateFallbackText();
            }
        },
    },
    methods: {
        updateNoResultOptionVisibility() {
            document.body.classList.toggle(HIDE_NO_RESULT_OPTION_CLASS, this.showPanel && !this.fallbackOptionVisible);
        },
        updateFallbackText() {
            this.selectedOptionsText = this.fallbackOptionEnabled ? '没有我想选择的用户' : '';
        },
        onNoRecord() {
            if (!this.fallbackOptionEnabled) {
                return;
            }
            this.selectedOptionsText = '没有我想选择的用户';
            this.formModel.userId = RESULT_FALLBACK_VALUE;
            this.onPickerValueChange();
            this.$emit('user-input');
            this.showPanel = false;
        },
        userIdValid(userId) {
            return userId && userId !== RESULT_FALLBACK_VALUE;
        },
        handlePopstate(e) {
            this.backed = true;
            e.preventDefault();
            this.showPanel = false;
        },
        async getUserInfo() {
            const { data } = await fetchUserDetail({
                targetUserId: this.formModel.userId,
                pageType: 13, // 13 才返回粉丝数
            });
            this.userInfo = data;
        },
        onClick() {
            if (!this.onClickForm()) {return;}
            this.showPanel = true;
            this.clickFormItemLog();
        },
        clickFormItemLog() {
            const params = {
                item_name: this.i18nLabel,
                item_info: this.formModel.userId === '' ? -1 : this.formModel.userId,
            };
            formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'CLICK', 'COLLECT_INFORMATION_ITEM', params);
        },
        async getUserList(val, reSearch = true) {
            const { data } = await fetchUserList({
                keyword: val,
                count: 10,
                page: this.page,
            });
            this.hasMoreData = data.hasMore;
            // 是否是重新搜索
            reSearch ? this.searchResult = data.itemList || [] : this.searchResult.push(...data.itemList);
            this.page = this.page + 1;
            this.showIo = true;
            this.showLoading = false;
        },
        handleSearch(val) {
            // 需要重置搜索参数
            this.resetSearchData();
            this.getUserList(val, true);
        },
        deleteHistory() {
            // 删除历史记录
            this.showHistoryDialog = true;
        },
        chooseClick(item, searchVal) {
            // 1.给form赋值 2. 更新tagList缓存 3.关闭弹窗 
            this.tagList = setSearchRecord(searchVal, STORAGE_KEY);
            this.formModel.userId = item.userId;
            this.onPickerValueChange();
            this.$emit('user-input');
            this.showPanel = false;
        },
        onPickerValueChange() {
            // 这里历史逻辑
            this.userInfo && this.setFormDataValueByPath(this.formModel.userId, this.outputPath);
            const res = this.setSelfFormDataValue(this.formModel.userId);
            if (res) {
                // 数据修改成功，抛出change 事件，触发依赖
                this.$emit('change');
            }
        },
        resetSearchData() {
            this.searchResult = [];
            this.hasMoreData = true;
            this.showIo = false;
            this.page = 0;
            this.showLoading = true;
        },
        loadMore(val) {
            this.getUserList(val, false);
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.userId = '';
                // 待定
                // this.onPickerValueChange('');
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.userId, newValue)) {
                this.formModel.userId = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const requiredValueMissing = this.formModel.userId === ''
                || !this.fallbackOptionEnabled && this.formModel.userId === RESULT_FALLBACK_VALUE;
            if (requiredValueMissing && this.props.required) {
                const errorMsg = this.i18n(this.props.errRequired, this.i18nLabel) || `${this.i18nLabel}不能为空`;
                this.errorMsg = errorMsg;
                this.validateFailureHandler(errorMsg);
                return false;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                this.errorMsg = '';
                return await promise;
            } catch (e) {
                this.errorMsg = e.userId[0].message;
                this.validateFailureHandler(e.userId[0].message);
                return false;
            }
        },
        clearValidate() {
            this.errorMsg = '';
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
    mounted() {
        if (!this.globalModel.preview) {
            console.log('[T12141714][user-select] C端账号选择器已加载', {
                showNoResultOption: this.fallbackOptionEnabled,
                showLoading: this.showLoading,
            });
        }
        // mounted钩子函数在组件挂载完成后立即执行，而input输入框的值还没有更新
        this.$nextTick(() => {
            const params = {
                item_name: this.i18nLabel,
                item_info: this.formModel.userId === '' ? -1 : this.formModel.userId,
            };
            !this.globalModel.preview && formEventBus.$emit(FORM_EVENTS_TYPE.SEND_FORM_LOG, 'SHOW', 'COLLECT_INFORMATION_ITEM', params);
        });
    },
    beforeDestroy() {
        document.body.classList.remove(HIDE_NO_RESULT_OPTION_CLASS);
    },
};
</script>
<style lang="less" scoped>
@import '../../style.less';
.user-item {
    padding: 0 19px;
    margin-bottom: 18px;
    margin-top: -6px;
}
.form-has-error-msg {
    margin-top: 16px;
}
/deep/.sp-form-item__content {
    .sp-form-item__error {
        left: 0;
        right: auto;
    }
    .sp-form-item__error:not(.has-error-msg) {
        display: none !important;
    }
}
</style>
<style lang="less">
body.hide-user-select-no-result-option {
    .user-panel .form-no-result {
        display: none;
    }
}
.delete-search {
    z-index: 2000 !important;;
}
</style>
